export const actionTypes = {
  todoTypes: {
    addTodo: 'add todo'
  }
};



// WEBPACK FOOTER //
// ./src/redux/constants.js